import { memo, useEffect, useRef } from '../../lib/teact/teact';

import buildClassName from '../../util/buildClassName';
import { createStreamParser, type StreamParser } from '../../util/streaming/streamingMarkdownRenderer';

import styles from './StreamingText.module.scss';

type OwnProps = {
  text: string;
  isStreaming: boolean;
};

const StreamingText = ({ text, isStreaming }: OwnProps) => {
  const containerRef = useRef<HTMLDivElement>();
  const parserRef = useRef<StreamParser>();
  const writtenLenRef = useRef(0);

  // Initialize parser on mount
  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    parserRef.current = createStreamParser(el);
    writtenLenRef.current = 0;

    return () => {
      parserRef.current?.end();
      parserRef.current = undefined;
      writtenLenRef.current = 0;
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Feed new text deltas to parser
  useEffect(() => {
    if (!parserRef.current) return;
    const newText = text.slice(writtenLenRef.current);
    if (newText) {
      parserRef.current.write(newText);
      writtenLenRef.current = text.length;
    }
    if (!isStreaming) {
      parserRef.current.end();
      parserRef.current = undefined;
    }
  }, [text, isStreaming]);

  return (
    <div
      ref={containerRef}
      className={buildClassName(styles.root, !isStreaming && styles.done)}
    />
  );
};

export default memo(StreamingText);
